/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_INT,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.INT,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.INT,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.INT,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.INT,
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.DEV_APP_ID,
      appCode: HereMapsCredentials.DEV_APP_CODE,
      useCIT: true
    }
  }
};

export default config;
